import React from 'react'
import moment from 'moment'
import * as css from '../../asignacion-fondos/Fondos.css'

let PropTypes = React.PropTypes
moment.locale('es')

export class RowRendiciones extends React.Component{
    constructor(props){
        super(props)
    }
    render() {
        return (
            <tr key={this.props.index}>
                <td className={css.tdIndex}>{this.props.index+1}</td>
                <td className={css.tdFecha}>{this.props.rendicion.rendidor}</td>
                <td className={css.tdFecha}>{this.props.rendicion.fecha_inicial}</td>
                <td className={css.tdFecha}>{this.props.rendicion.fecha_final}</td>
                <td className={css.tdLocal}>{this.props.rendicion.fondos_viatico}</td>
                <td className={css.tdComuna}>{this.props.rendicion.fondos_rendir}</td>
                <td className={css.tdRegion}>{this.props.rendicion.total_gastos}</td>
                <td className={css.tdJornada}>{this.props.rendicion.diferencia}</td>
                <td className={css.tdDotacion}>
                    <a className="btn btn-xs btn-info"
                       href={`/rendicion/${this.props.rendicion.idRendicion}/detalle`} target="_blank">
                        <span className={'glyphicon glyphicon-eye-open'}></span>
                    </a>
                </td>
            </tr>
        )
    }
}


// WEBPACK FOOTER //
// ./frontEnd/contabilidad/revision-rendiciones/rendiciones/RowRendiciones.jsx